module.exports = __webpack_public_path__ + "static/media/公司banner.dc95a676.png";